package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusProperties
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.button.custom.EsListDialogButton
import com.essntl.uikit.components.tooltip.EsTooltip

@Composable
fun TravelAgentDialogButton(
    travelAgent: TravelAgentModel?,
    onClick: (TravelAgentModel) -> Unit,
    modifier: Modifier = Modifier,
) {
    val clientDisplayName =
        remember(travelAgent?.contact?.firstName, travelAgent?.contact?.lastName) {
            travelAgent?.prettyName ?: "-"
        }

    EsTooltip(
        text = if (travelAgent == null) "No Travel Agent" else
            clientDisplayName,
    ) {
        EsListDialogButton(
            onClick = {
                if (travelAgent != null)
                    onClick(travelAgent)
            },
            text = clientDisplayName,
            modifier = modifier.focusProperties { canFocus = false },
        )
    }
}